/* @flow weak */
import { capitalize } from 'lodash';
import React from 'react';
import Dialog from 'components/Dialog.jsx';
import BoxBody from 'components/BoxBody.jsx';
import Form from 'components/Form.jsx';
import FormInput from 'components/FormInput.jsx';
import FormSelect from 'components/FormSelect.jsx';
import Button from 'components/Button.jsx';
import States from 'lib/USState';
import OrganizationActions from 'actions/OrganizationActions';
import ToastActions from 'actions/ToastActions';

import { OrganizationTypes } from 'constants/OrganizationConstants';

import './styles/OrganizationCreateModal.scss';

class OrganizationCreateModal extends React.Component {
  static propTypes = {
    onCreate: React.PropTypes.func.isRequired,
    defaultOrganization: React.PropTypes.string,
    organizationType: React.PropTypes.oneOf(Object.keys(OrganizationTypes)),
  };

  static defaultProps = {
    organizationType: OrganizationTypes.SCHOOL,
  };

  state = {
    canSubmit: false,
  };

  disableButton = () => {
    this.setState({ canSubmit: false });
  };

  enableButton = () => {
    this.setState({ canSubmit: true });
  };

  submit = (values) => {
    values.type = capitalize(this.props.organizationType.toLowerCase());
    OrganizationActions.createOrganization(values).then(organization => {
      this.props.onRequestHide();
      this.props.onCreate(organization);
    }, ToastActions.showAPIError);
  };

  render() {
    return (
      <Dialog
        eventScreenName="OrganizationCreateModal"
        {...this.props}
        title={`Add your ${this.props.organizationType.toLowerCase()}`}
        size="small"
        className="OrganizationCreateModal">
        <BoxBody divided>
          <Form
            onValidSubmit={this.submit}
            onValid={this.enableButton}
            onInvalid={this.disableButton}>

            <div className="OrganizationCreateModal-row">
              <div className="OrganizationCreateModal-item full">
                <FormInput
                  label={`${capitalize(this.props.organizationType.toLowerCase())} name`}
                  value={this.props.defaultOrganization}
                  name="name"
                  required
                  validationErrors={{
                    isDefaultRequiredValue: 'Your school name is required.',
                  }}
                />
              </div>
            </div>

            <div className="OrganizationCreateModal-row">
              <div className="OrganizationCreateModal-item full">
                <FormInput
                  label="City"
                  name="city"
                  required
                  validationErrors={{
                    isDefaultRequiredValue: 'Your city is required.',
                  }}
                />
              </div>
            </div>

            <div className="OrganizationCreateModal-row">
              <div className="OrganizationCreateModal-item full">
                <FormSelect
                  label="State"
                  name="state"
                  required
                  validationErrors={{
                    isDefaultRequiredValue: 'Please select a state',
                  }}
                  options={States}
                />
              </div>
            </div>

            <Button
              className="OrganizationCreateModal-submit"
              disabled={!this.state.canSubmit}
              eventElementName="OrganizationCreateModal-submit">
              Save
            </Button>
          </Form>
        </BoxBody>
      </Dialog>
    );
  }
}

export default OrganizationCreateModal;



// WEBPACK FOOTER //
// ./src/organizations/components/OrganizationCreateModal.jsx